// extracted by mini-css-extract-plugin
export var configurationSection = "_re-0";